import { cloneDeep } from 'lodash';
import { FieldTypes } from './cx-adv-filters.types';

const FIELD_CREATOR_OPTIONS: any = {
  [FieldTypes.Enum]: [
    // {
    //     label: 'Contain exactly',
    //     value: 'contain',
    //     field_options: [
    //         {
    //             selected: '',
    //             placeholder: "Hint: value1, value2",
    //             type: 'chip'
    //         }
    //     ]
    // },
    // {
    //     label: 'Does’nt contain exactly',
    //     value: 'not-contain',
    //     field_options: [
    //         {
    //             selected: '',
    //             placeholder: "Hint: value1, value2",
    //             type: 'chip'
    //         }
    //     ]
    // },
    {
      label: 'is',
      value: 'is',
      field_options: [
        {
          type: 'dropdown',
          placeholder: 'Today',
          selected: '',
          values: [],
        },
      ],
    },
    {
      label: 'is not',
      value: 'is-not',
      field_options: [
        {
          type: 'dropdown',
          placeholder: 'Today',
          selected: '',
          values: [],
        },
      ],
    },
  ],
  [FieldTypes.EnumMulti]: [
    {
      label: 'in',
      value: 'in',
      field_options: [
        {
          type: 'multiselect',
          placeholder: '',
          selected: '',
          values: [],
        },
      ],
    },
    {
      label: 'not in',
      value: 'not-in',
      field_options: [
        {
          type: 'multiselect',
          placeholder: '',
          selected: '',
          values: [],
        },
      ],
    },
  ],
  [FieldTypes.String]: [
    {
      label: 'Contain exactly',
      value: 'contain',
      field_options: [
        {
          selected: '',
          placeholder: 'Value',
          type: 'chip',
        },
      ],
    },
    {
      label: 'Doesn’t contain exactly',
      value: 'not-contain',
      field_options: [
        {
          selected: '',
          placeholder: 'Value',
          type: 'chip',
        },
      ],
    },
    // {
    //     label: 'Is known',
    //     value: 'exists',
    // },
    // {
    //     label: 'Is unknown',
    //     value: 'not-exists'
    // }
  ],
  [FieldTypes.Number]: [
    {
      label: 'is equal to',
      value: 'is-equal',
      field_options: [
        {
          label: '',
          selected: '',
          type: 'input',
          inputType: 'number',
          placeholder: 'Enter value',
        },
      ],
    },
    {
      label: 'is more than',
      value: 'is-more-than',
      field_options: [
        {
          label: '',
          selected: '',
          type: 'input',
          inputType: 'number',
          placeholder: 'Enter value',
        },
      ],
    },
    {
      label: 'is less than',
      value: 'is-less-than',
      field_options: [
        {
          label: '',
          selected: '',
          type: 'input',
          inputType: 'number',
          placeholder: 'Enter value',
        },
      ],
    },
  ],
  [FieldTypes.DateTime]: [
    {
      label: 'is',
      value: 'is',
      field_options: [
        {
          type: 'dropdown',
          placeholder: 'Today',
          selected: '',
          values: [
            { label: 'Select', value: '', desc: '' },
            { label: 'Today', value: 'today', desc: '' },
            { label: 'Yesterday', value: 'yesterday', dsec: '' },
          ],
        },
      ],
    },
    {
      label: 'is equal to',
      value: 'is-equal',
      field_options: [
        {
          selected: '',
          type: 'date',
          placeholder: 'MM/DD/YY',
        },
      ],
    },
    // {
    //     label: 'is before',
    //     value: 'is-before',
    //     field_options: [
    //         {
    //             selected: '',
    //             type: 'date',
    //             placeholder: "MM/DD/YY"
    //         }
    //     ]
    // },
    // {
    //     label: 'is after',
    //     value: 'is-after',
    //     field_options: [
    //         {
    //             selected: '',
    //             type: 'date',
    //             placeholder: "MM/DD/YY"
    //         }
    //     ]
    // },
    {
      label: 'is between',
      value: 'is-between',
      field_options: [
        {
          label: 'From',
          selected: '',
          type: 'date',
          placeholder: 'MM/DD/YY',
        },
        {
          label: 'To',
          selected: '',
          type: 'date',
          placeholder: 'MM/DD/YY',
        },
      ],
    },
    {
      label: 'is more than',
      value: 'is-more-than',
      field_options: [
        {
          label: '',
          selected: '1',
          type: 'input',
          inputType: 'number',
          placeholder: '1',
        },
        {
          type: 'dropdown',
          placeholder: 'a-day-ago',
          selected: 'a-day-ago',
          values: [
            { label: 'day ago', value: 'a-day-ago', desc: '' },
            // { label: 'day from now', value: 'day-from-now', dsec: '' }
          ],
        },
      ],
    },
    {
      label: 'is less than',
      value: 'is-less-than',
      field_options: [
        {
          label: '',
          selected: '1',
          type: 'input',
          inputType: 'number',
          placeholder: '1',
        },
        {
          type: 'dropdown',
          placeholder: 'a-day-ago',
          selected: 'a-day-ago',
          values: [
            { label: 'day ago', value: 'a-day-ago', desc: '' },
            // { label: 'day from now', value: 'day-from-now', dsec: '' }
          ],
        },
      ],
    },
    // {
    //     label: 'Is known',
    //     value: 'exists',
    // },
    // {
    //     label: 'Is unknown',
    //     value: 'not-exists'
    // }
  ],
  [FieldTypes.Time]: [
    {
      label: 'is equal to',
      value: 'is-equal',
      field_options: [
        {
          selected: '',
          type: 'time',
          placeholder: 'hh:mm',
        },
      ],
    },
    {
      label: 'is before',
      value: 'is-before',
      field_options: [
        {
          selected: '',
          type: 'time',
          placeholder: 'hh:mm',
        },
      ],
    },
    {
      label: 'is after',
      value: 'is-after',
      field_options: [
        {
          selected: '',
          type: 'time',
          placeholder: 'hh:mm',
        },
      ],
    },
    // {
    //     label: 'Is known',
    //     value: 'exists',
    // },
  ],
};

export const OptionsLabelMapped: any = {
  'a-day-ago': 'days ago',
};

export const getCreatorFieldOptions = () => {
  return cloneDeep(FIELD_CREATOR_OPTIONS);
};
